export default {
  answer(state) {
    return state.answer
  },
  isSaving(state) {
    return state.isSaving
  },
}
